import type { ExperimentalMutations } from '../__types__/ExperimentalMutations'; //eslint-disable-line no-restricted-imports
import { MediaType } from '../MediaType';
import { throwErrorWithResponse } from '../throwErrorWithResponse';

export const experimentalAnalyticsSetRestrictionsBySpace: ExperimentalMutations['experimentalAnalyticsSetRestrictionsBySpace'] =
	(_, { cloudId, spaceKey, spaceId, restrictions }, { network }) => {
		return network
			.cfetch(
				`/gateway/api/ex/confluence/${cloudId}/analytics/space/restrictions?spaceKey=${spaceKey}&spaceId=${spaceId}`,
				{
					method: 'PUT',
					credentials: 'include',
					headers: {
						'Content-Type': MediaType.JSON,
					},
					body: JSON.stringify({ restrictions: restrictions }),
				},
			)
			.then((response) => {
				return response.json().catch((error) => throwErrorWithResponse(error, response));
			});
	};
